import { FC } from 'react';
import { AnalyticsLineChart } from 'shared/ui/Analytics/AnalyticsLineChart';
import { LineChartData } from 'shared/ui/Analytics/types';
import { getRenamedLineChartData } from '../../../lib/getRenamedLineChartData';

interface ObjectOpenedSelectionChartProps {
  pointsData: LineChartData[];
  minWidth: number;
}

const chartLines = [
  { key: 'line', label: 'Открытие объекта в подборках', color: '#DC143C' },
];

export const ObjectOpenedSelectionChart: FC<
  ObjectOpenedSelectionChartProps
> = ({ pointsData, minWidth }) => {
  const renamedPointsData = getRenamedLineChartData(pointsData, chartLines);

  return (
    <AnalyticsLineChart
      data={renamedPointsData}
      lineLabels={chartLines.map((l) => l.label)}
      lineColors={chartLines.map((l) => l.color)}
      height={200}
      minWidth={minWidth}
    />
  );
};
